const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/compiled/source-map08");